import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-marketing-email-icon',
  templateUrl: './marketing-email-icon.component.html',
  styleUrls: ['./marketing-email-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarketingEmailIconComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
